import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useLaunch } from '../contexts/LaunchContext';
import '../styles/Navbar.css';
import UserLogin from './UserLogin';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isResourcesOpen, setIsResourcesOpen] = useState(false);
  const { user, isAdmin } = useAuth();
  const { isLaunched, appStoreUrl } = useLaunch();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
      <div className="navbar-container">
        <Link to="/" className="logo">
          <img src={process.env.PUBLIC_URL + "/logoNBG.png"} alt="LogiCar Logo" />
          <span className="logo-text">
            <span className="logi-text">Logi</span><span className="car-text">Car</span>
          </span>
        </Link>
        <div className="mobile-menu-button" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div className={`nav-links ${isMobileMenuOpen ? 'active' : ''}`}>
          <Link to="/" className="home-link">
            <i className="fas fa-home"></i>
            Home
          </Link>
          <Link to="/about">About</Link>
          <Link to="/features">Features</Link>
          <div className="dropdown" onMouseEnter={() => setIsResourcesOpen(true)} onMouseLeave={() => setIsResourcesOpen(false)}>
            <button className="dropdown-toggle">
              Resources
              <i className="fas fa-chevron-down"></i>
            </button>
            <div className={`dropdown-menu ${isResourcesOpen ? 'active' : ''}`}>
              <Link to="/blog" onClick={() => setIsMobileMenuOpen(false)}>
                <i className="fas fa-blog"></i>
                Blog
              </Link>
              <Link to="/faq" onClick={() => setIsMobileMenuOpen(false)}>
                <i className="fas fa-question-circle"></i>
                FAQ
              </Link>
            </div>
          </div>
          {user && !isAdmin && (
            <Link to="/app" className="dashboard-link">
              <i className="fas fa-tachometer-alt"></i>
              Dashboard
            </Link>
          )}
          {isAdmin && (
            <Link to="/admin" className="admin-link">
              <i className="fas fa-cog"></i>
              Admin Panel
            </Link>
          )}
          <UserLogin />
          {isLaunched ? (
            <a
              href={appStoreUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="signup-nav-button"
            >
              Get LogiCar
            </a>
          ) : (
            <button 
              onClick={() => scrollToSection('signup')} 
              className="signup-nav-button"
            >
              Notify Me
            </button>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar; 
